import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { getSearchListShows } from '../../services/content.service';
import { MULTIPLE_CAT_PER_SHOW } from '../../config/const.config';

const Shows = ({ id, name, defaultValue, label, onChange, sx, error }) => {
  const [booksData, setBooksData] = useState([]);

  const [selectedValue, setSelectedValue] = useState(defaultValue || '');

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    onChange(event);
  };

  useEffect(() => {
    getSearchListShows()
      .then((res) => {
        setBooksData(res.data);
      })
      .catch(() => {
        // nothing
      });
  }, []);

  return (
    <FormControl fullWidth error={error !== ''}>
      <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>

      {MULTIPLE_CAT_PER_SHOW && (
        <Select
          labelId="demo-simple-select-label"
          id={id}
          name={name}
          value={selectedValue}
          label={label}
          onChange={handleChange}
          sx={sx}
        >
          {booksData.map((k) => (
            <MenuItem
              sx={{ '&:hover': { backgroundColor: '#7B61FF' } }}
              key={`${id}-v-${k.id}`}
              value={`[${k.id}] - ${k.title}`}
            >
              {`${k.title}`}
            </MenuItem>
          ))}
        </Select>
      )}

      {error !== '' && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

Shows.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
Shows.defaultProps = {
  sx: {},
  error: '',
  defaultValue: '',
};

export default Shows;
